import forge from "node-forge";

/**
 * Encrypts a JSON body using AES-CBC with the provided secret key.
 * @param {Object} body - The request body to encrypt.
 * @param {string} secretKey - The secret key for encryption.
 * @returns {string} - The encrypted body in Base64 format (includes IV).
 */
export const encryptBody = (body, secretKey) => {
  const shouldEncrypt = process.env.REACT_APP_ENCRYPT_RESPONSE === "true";

  if (!secretKey) throw new Error("Secret key is not provided");
  if (!shouldEncrypt) {
    return JSON.stringify(body); // Return plain text
  }

  // Convert the body to a JSON string
  const bodyString = JSON.stringify(body);

  // Ensure the secret key is the correct length for AES (16 bytes for AES-128)
  const key = forge.util.createBuffer(secretKey).getBytes(16); // Truncate or pad to 16 bytes

  // Generate a random Initialization Vector (IV)
  const iv = forge.random.getBytesSync(16);

  // Initialize Forge cipher with AES encryption (AES-CBC mode)
  const cipher = forge.cipher.createCipher("AES-CBC", key);
  cipher.start({ iv: iv });
  cipher.update(forge.util.createBuffer(bodyString));
  cipher.finish();

  // Combine IV and encrypted data, encode as Base64
  const encryptedData = iv + cipher.output.getBytes();

  // Return the Base64-encoded result
  return forge.util.encode64(encryptedData);
};



